export default {
    common: {
        actions: {
            add: 'Add',
            edit: 'Edit',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            close: 'Close',
            search: 'Search',
            filter: 'Filter',
            export: 'Export',
            back: 'Back',
            confirm: 'Confirm',
            refresh: 'Refresh',
            download: 'Download',
            retry: 'Retry',
            generate: 'Generate',
        },
        labels: {
            date: 'Date',
            status: 'Status',
            actions: 'Actions',
            type: 'Type',
            all: 'All',
            total: 'Total',
            name: 'Name',
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
            pending: 'Pending',
        },
        messages: {
            loading: 'Loading…',
            noData: 'No data',
            error: 'An error occurred',
            success: 'Success',
        },
    },
    settings: {
        title: 'Settings',
        language: 'Language',
        languageHint: 'Select your preferred language',
    },
}
